import React, { useState } from "react";
import { useEffect } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label,
  Button,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

import { Colxx } from "../../../components/common/CustomBootstrap";
import { useHistory } from "react-router-dom";
import PeerRatingTab from "../peerrating/PeerRatingTab";
import { userContext } from "../../../context";
import { ProfileService } from "../../../services/ProfileService";
import { Stringutility } from "../../../utilities/stringutility";
import { Constants } from "../../../constants/constantValues";

const AskPeerRating = () => {
  const history = useHistory();
  const [modalRight, setModalRight] = useState(false);
  const [ispreferedEmail, setPreferedEmail] = useState(true);
  const [peerContactNumber, setPeerContactNumber] = useState("");
  const [selectionId, setSelectionId] = useState("");
  const [showPersonal, setShowPersonal] = useState(false);
  const [showEmployer, setShowEmployer] = useState(false);
  const [experiencesList, setExperiencesList] = useState(
    JSON.parse(localStorage.getItem("experincelist")) || []
  );
  const [requestId, setRequestId] = useState("");
  const [workedSameTeam, setWorkedSameTeam] = useState(false);
  const [workedDiffTeams, setWorkedDiffTeams] = useState(false);
  const [youSupervisedPeer, setYouSupervisedPeer] = useState(false);
  const [b2bRelation, setB2bRelation] = useState(false);
  const [customerRelation, setCustomerRelation] = useState(false);
  const [peerSupervisedYou, setPeerSupervisedYou] = useState(false);
  const [mentoringOrTraining, setMentoringOrTraining] = useState(false);
  const [academicRelation, setAcademicRelation] = useState(false);
  const [personalRelation, setPersonalRelation] = useState(false);
  const [expId, setExpId] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [peerRequestList, setPeerRequestList] = useState([]);

  const [inputField, setInputField] = useState({
    firstName: "",
    lastName: "",
    email: "",
    description: "",
  });

  let count = 0;

  useEffect(() => {
    window.localStorage.getItem("experincelist");
  }, []);

  useEffect(() => {
    setInputField((prevState) => ({
      ...prevState,
      description:
        " Can you please rate my skills ? I am using Teamanics, a new career platform that uses peer ratings of skills to match people to jobs.",
    }));
    getCandidateExperiences();
    getReviewDetails();
  }, [5]);

  const getReviewDetails = () => {
    const peerReqStatus = "REQ_CREATED&REQ_EMAIL_SENT";
    ProfileService.getRatingReview(peerReqStatus).then((response) => {
      try {
        var peerRatinhDetails = response.data;
        if (peerRatinhDetails != null) {
          if (peerRatinhDetails.peerList.length > 0) {
            setPeerRequestList(peerRatinhDetails.peerList);

            window.localStorage.setItem(
              "peerrequestlist",
              peerRatinhDetails.peerList
            );
          }
        }
      } catch (err) {
        console.error("getRatingReview" + JSON.stringify(err));
      }
    });
  };
  const askPeerRating = () => {
    // setShowPeerRatingForm(true);
    setModalRight(true);
  };

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePreferContact = (event) => {
    if (event.target.value == "Email") {
      setPreferedEmail(true);
    } else {
      setPreferedEmail(false);
    }
  };

  const peerContactHandleChange = (event) => {
    const result = event.target.value.replace(/\D/g, "");
    setPeerContactNumber(result);
  };

  const handleSelectionChange = (e) => {
    setSelectionId(e.target.value);
    if (e.target.value == "personal") {
      setShowPersonal(true);
      setPersonalRelation(true);
      setShowEmployer(false);
      setExpId("");
    } else if (e.target.value == "") {
      setShowPersonal(false);
      setShowEmployer(false);
      setExpId("");
    } else {
      setShowPersonal(true);
      setShowEmployer(true);
      setExpId(e.target.value);
    }
  };

  function onCountryCodeChange(e) {
    setCountryCode(e.target.value);
  }

  const updateWorkedSameTeam = () => setWorkedSameTeam(!workedSameTeam);
  const updateworkedDiffTeams = () => setWorkedDiffTeams(!workedDiffTeams);
  const updateYouSupervisedPeer = () =>
    setYouSupervisedPeer(!youSupervisedPeer);
  const updatePeerSupervisedYou = () =>
    setPeerSupervisedYou(!peerSupervisedYou);
  const updateB2BRelation = () => setB2bRelation(!b2bRelation);
  const updateMentoringOrTraining = () =>
    setMentoringOrTraining(!mentoringOrTraining);
  const updateCustomerRelation = () => setCustomerRelation(!customerRelation);
  const updateAcademicRelation = () => setAcademicRelation(!academicRelation);

  const getCandidateExperiences = () => {
    ProfileService.getExperience().then((response) => {
      try {
        if (response.data !== null) {
          var experienceDetails = response.data;
          if (experienceDetails.exps != null) {
            response.data.exps.length > 0 &&
              response.data.exps.map((experience) => {
                const obj = {
                  key: experience.id,
                  value: experience.employer,
                };
                experiencesList.push(obj);
              });
          }
          setExperiencesList(experiencesList);
          window.localStorage.setItem("experincelist" + experiencesList);
        }
      } catch (err) {
        console.error("getExperience" + JSON.stringify(err));
      }
    });
  };

  const sendPeerRequest = (event) => {
    let firstName = Stringutility.getValue(inputField.firstName);
    if (firstName == "") {
      Stringutility.showErrorMessage(Constants.enterFirstName);
      return;
    }

    let lastName = Stringutility.getValue(inputField.lastName);
    if (lastName == "") {
      Stringutility.showErrorMessage(Constants.enterLastName);
      return;
    }

    let email = Stringutility.getValue(inputField.email);
    if (ispreferedEmail) {
      if (email == "") {
        Stringutility.showErrorMessage(Constants.enterEmail);
        return;
      }
    } else {
      if (Stringutility.getValue(peerContactNumber) == "") {
        Stringutility.showErrorMessage(Constants.enterPhoneNumber);
        return;
      }
    }

    if (selectionId == 0) {
      Stringutility.showErrorMessage(Constants.howDoYouKnowThisPerson);
      return;
    }

    const peerRequest = {
      firstName: inputField.firstName,
      lastName: inputField.lastName,
      email: inputField.email,
      contactNumber: countryCode + "" + peerContactNumber,
      workedSameTeam: workedSameTeam,
      youSupervisedPeer: youSupervisedPeer,
      b2bRelation: b2bRelation,
      customerRelation: customerRelation,
      workedDiffTeams: workedDiffTeams,
      peerSupervisedYou: peerSupervisedYou,
      mentoringOrTraining: mentoringOrTraining,
      academicRelation: academicRelation,
      personalMessage: inputField.description,
      personalRelation: personalRelation,
      experienceId: expId,
    };

    if (requestId == "") {
      ProfileService.addPeerRating(peerRequest).then((response) => {
        try {
          Stringutility.showSuccessMessage(
            Constants.peerRequestAddedSuccessfully
          );
          window.sessionStorage.setItem("request_id", response.data.id);
          setInputField((prevState) => ({
            ...prevState,
            firstName: "",
            lastName: "",
            email: "",
          }));
          setPeerContactNumber("");

          setModalRight(false);
          event.preventDefault();
          getReviewDetails();
          getCandidateExperiences();
        } catch (err) {
          console.error("addPeerRating" + JSON.stringify(err));
        }
      });
    } else {
      ProfileService.updatePeerRating(peerRequest, requestId).then(
        (response) => {
          try {
            Stringutility.showSuccessMessage(
              Constants.peerRequestUpdatedSuccessfully
            );
            setInputField((prevState) => ({
              ...prevState,
              firstName: "",
              lastName: "",
              email: "",
            }));
            setPeerContactNumber("");

            getReviewDetails();
            getCandidateExperiences();
          } catch (err) {
            console.error("updatePeerRating" + JSON.stringify(err));
          }
        }
      );
    }
  };

  const clearFormData = () => {
    setExpId("");
    setInputField((prevState) => ({
      ...prevState,
      firstName: "",
      lastName: "",
      email: "",
    }));
    setPeerContactNumber("");
    setModalRight(false);
    setWorkedSameTeam(false);
    setWorkedDiffTeams(false);
    setYouSupervisedPeer(false);
    setPeerSupervisedYou(false);
    setB2bRelation(false);
    setMentoringOrTraining(false);
    setCustomerRelation(false);
    setAcademicRelation(false);
    setRequestId("");
  };

  return (
    <userContext.Provider value={peerRequestList}>
      <Row className="boday-type-Margin">
        <Colxx xxs="12">
          <Card className="ask-panel-border-radius">
            <CardBody>
              <div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="">
                      <div className="skill-header">
                        <div>
                          <div className="profile-card-title">
                            <label>
                              <h2>Peer rating</h2>
                            </label>
                          </div>
                        </div>
                        <div>
                          <Button
                            color="primary"
                            outline
                            onClick={askPeerRating}
                          >
                            Send rating request
                          </Button>
                        </div>
                      </div>
                      <Modal
                        isOpen={modalRight}
                        toggle={() => setModalRight(!modalRight)}
                        wrapClassName="modal-right"
                      >
                        <ModalHeader>Ask to peer</ModalHeader>
                        <ModalBody>
                          <div>
                            <Form>
                              <FormGroup row>
                                <Colxx sm={12}>
                                  <FormGroup>
                                    <Label for="exampleEmailGrid">
                                      First Name{" "}
                                      <span className="required-star"></span> :
                                    </Label>
                                    <Input
                                      type="text"
                                      name="firstName"
                                      data-testid="askpeerrating-firstName"
                                      onChange={inputsHandler}
                                      value={inputField.firstName}
                                    />
                                  </FormGroup>
                                </Colxx>

                                <Colxx sm={12}>
                                  <FormGroup>
                                    <Label for="exampleEmailGrid">
                                      Last Name{" "}
                                      <span className="required-star"></span> :
                                    </Label>
                                    <Input
                                      type="text"
                                      name="lastName"
                                      data-testid="askpeerrating-lastName"
                                      onChange={inputsHandler}
                                      value={inputField.lastName}
                                    />
                                  </FormGroup>
                                </Colxx>
                              </FormGroup>

                              <FormGroup row>
                                <Colxx sm={12}>
                                  <FormGroup>
                                    <Label for="exampleEmailGrid">
                                      Prefered Contact Type
                                    </Label>
                                    <Input
                                      type="select"
                                      onChange={handlePreferContact}
                                    >
                                      <option>Email</option>
                                      <option>Phone Number</option>
                                    </Input>
                                  </FormGroup>
                                </Colxx>

                                {ispreferedEmail ? (
                                  <Colxx sm={12}>
                                    <FormGroup>
                                      <Label for="exampleEmailGrid">
                                        Email{" "}
                                        <span className="required-star"></span>{" "}
                                        :
                                      </Label>
                                      <Input
                                        type="text"
                                        name="email"
                                        data-testid="askpeerrating-email"
                                        onChange={inputsHandler}
                                        value={inputField.email}
                                      />
                                    </FormGroup>
                                  </Colxx>
                                ) : (
                                  <Colxx sm={12}>
                                    <FormGroup>
                                      <Label for="exampleEmailGrid">
                                        Phone Number{" "}
                                        <span className="required-star"></span>{" "}
                                        :
                                      </Label>
                                      <div className="mb-3 input-group">
                                        <div className="input-group-prepend">
                                          <Input
                                            type="select"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            onChange={onCountryCodeChange}
                                            value={countryCode}
                                          >
                                            <option key="+1" value="+1">
                                              +1
                                            </option>
                                            <option key="+91" value="+91">
                                              +91
                                            </option>
                                          </Input>
                                        </div>
                                        <Input
                                          international
                                          withCountryCallingCode
                                          type="text"
                                          name="peerContactNumber"
                                          data-testid="askpeerrating-peerContactNumber"
                                          onChange={peerContactHandleChange}
                                          value={peerContactNumber}
                                        />
                                      </div>
                                    </FormGroup>
                                  </Colxx>
                                )}
                              </FormGroup>

                              <FormGroup row>
                                <Colxx sm={12}>
                                  <FormGroup>
                                    <label>
                                      How do you know this person?{" "}
                                      <span className="required-star"></span> :
                                    </label>
                                    <Input
                                      type="select"
                                      value={selectionId}
                                      onChange={handleSelectionChange}
                                    >
                                      <option value="">Please select</option>
                                      <option value="personal">
                                        Personal Relationship
                                      </option>
                                      {experiencesList.length > 0 &&
                                        experiencesList.map(
                                          ({ value, key }) => (
                                            <option value={key}>{value}</option>
                                          )
                                        )}
                                    </Input>
                                  </FormGroup>
                                </Colxx>
                              </FormGroup>

                              {showEmployer && (
                                <div className="dropzone mb-4">
                                  <FormGroup row className="mt-2 ml-2">
                                    <Colxx sm={12}>
                                      <div className="row form-group">
                                        <div className="col-sm-12">
                                          <div className="custom-checkbox custom-control custom-control-inline">
                                            <input
                                              type="checkbox"
                                              data-testid="askpeerrating-workedSameTeam"
                                              className="custom-control-input"
                                              name="workedSameTeam"
                                              checked={workedSameTeam}
                                              onChange={updateWorkedSameTeam}
                                              id="workedinthesameteam"
                                            />
                                            <label
                                              className="custom-control-label"
                                              for="workedinthesameteam"
                                            >
                                              Worked in the same team
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-sm-12">
                                          <div className="custom-checkbox custom-control custom-control-inline">
                                            <input
                                              type="checkbox"
                                              data-testid="askpeerrating-workedDiffTeams"
                                              className="custom-control-input"
                                              checked={workedDiffTeams}
                                              onChange={updateworkedDiffTeams}
                                            />
                                            <label
                                              className="custom-control-label"
                                              for="exCustomInline"
                                            >
                                              Worked in the different team
                                            </label>
                                          </div>
                                        </div>

                                        <div className="col-sm-12">
                                          <div className="custom-checkbox custom-control custom-control-inline">
                                            <input
                                              type="checkbox"
                                              data-testid="askpeerrating-youSupervisedPeer"
                                              className="custom-control-input"
                                              checked={youSupervisedPeer}
                                              onChange={updateYouSupervisedPeer}
                                            />
                                            <label
                                              className="custom-control-label"
                                              for="youSupervisedPeer"
                                            >
                                              You supervised peer
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-sm-12">
                                          <div className="custom-checkbox custom-control custom-control-inline">
                                            <input
                                              type="checkbox"
                                              data-testid="askpeerrating-peerSupervisedYou"
                                              className="custom-control-input"
                                              checked={peerSupervisedYou}
                                              onChange={updatePeerSupervisedYou}
                                            />
                                            <label
                                              className="custom-control-label"
                                              for="exCustomInline"
                                            >
                                              peer supervised you
                                            </label>
                                          </div>
                                        </div>

                                        <div className="col-sm-12">
                                          <div className="custom-checkbox custom-control custom-control-inline">
                                            <input
                                              type="checkbox"
                                              data-testid="askpeerrating-b2bRelation"
                                              className="custom-control-input"
                                              checked={b2bRelation}
                                              onChange={updateB2BRelation}
                                            />
                                            <label
                                              className="custom-control-label"
                                              for="exCustomInline"
                                            >
                                              Business to business relationship
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-sm-12">
                                          <div className="custom-checkbox custom-control custom-control-inline">
                                            <input
                                              type="checkbox"
                                              data-testid="askpeerrating-mentoringOrTraining"
                                              className="custom-control-input"
                                              checked={mentoringOrTraining}
                                              onChange={
                                                updateMentoringOrTraining
                                              }
                                            />
                                            <label
                                              className="custom-control-label"
                                              for="exCustomInline"
                                            >
                                              Mentoring or training relationship
                                            </label>
                                          </div>
                                        </div>

                                        <div className="col-sm-12">
                                          <div className="custom-checkbox custom-control custom-control-inline">
                                            <input
                                              type="checkbox"
                                              data-testid="askpeerrating-customerRelation"
                                              className="custom-control-input"
                                              checked={customerRelation}
                                              onChange={updateCustomerRelation}
                                            />
                                            <label
                                              className="custom-control-label"
                                              for="exCustomInline"
                                            >
                                              Customer relationship
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-sm-12">
                                          <div className="custom-checkbox custom-control custom-control-inline">
                                            <input
                                              type="checkbox"
                                              data-testid="askpeerrating-academicRelation"
                                              className="custom-control-input"
                                              checked={academicRelation}
                                              onChange={updateAcademicRelation}
                                            />
                                            <label
                                              className="custom-control-label"
                                              for="exCustomInline"
                                            >
                                              Academic relationship
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </Colxx>{" "}
                                  </FormGroup>
                                </div>
                              )}

                              {showPersonal && (
                                <FormGroup row>
                                  <Colxx sm={12}>
                                    <label>
                                      Include a personalized message with your
                                      request.
                                    </label>
                                    <Input
                                      rows="4"
                                      data-testid="askpeerrating-description"
                                      type="textarea"
                                      name="description"
                                      onChange={inputsHandler}
                                      value={inputField.description}
                                    />
                                  </Colxx>
                                </FormGroup>
                              )}

                              <div className="mt-4">
                                <Button
                                  color="primary"
                                  className="mr-2"
                                  onClick={sendPeerRequest}
                                >
                                  Send rating request
                                </Button>
                                <Button color="primary" onClick={clearFormData}>
                                  Cancel
                                </Button>
                              </div>
                            </Form>
                          </div>
                        </ModalBody>
                      </Modal>
                    </div>
                    <hr></hr>
                    <PeerRatingTab />
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    </userContext.Provider>
  );
};

export default AskPeerRating;
